<template>
  <div class="nav_box" :style="{'height':!noshadow?'50px': '46px'}">
    <van-nav-bar
      class="nav"
      :class="{'shadow': !noshadow}"
      :z-index="99"
      @click-left="onClickLeft"
      @click-right="onClickRight"
      :style="{'background-color': bgc}"
      :border="isborder"
    >
      <div slot="left" :style="{'color': font_c}"><van-icon name="arrow-left" :color="font_c"  size=".5rem"/>{{leftText}}</div>
      <div slot="title" :style="{'color': font_c}" class="overell">{{title}}</div>
      <div slot="right" v-if="rightText" :style="{'color': font_c}">{{rightText}}</div>
      <van-icon v-if="rightName" :name="rightName" slot="right" size="30px" :color="font_c"/>
    </van-nav-bar>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    leftText: String,
    rightText: String,
    bgc: String,
    noshadow: Boolean,
    rightName: String,
    font_c: {
      type: String,
      default () {
        return '#333333'
      }
    },
    isborder: Boolean
  },
  data () {
    return {
    }
  },
  watch: {
    '$route' (val) {
      console.log(val)
    }
  },
  created () {
    console.log(2)
  },
  methods: {
    onClickLeft () {
      history.go(-1)
    },
    onClickRight () {
      this.$emit('onClickRight')
    }
  }
}
</script>

<style scoped>
.nav_box{
  height: 46px;/*no*/
}
.nav{
  position: fixed;
  top:0;
  left: 0;
  z-index: 99;
  width: 100%;
}
.shadow{
  box-shadow: 0 0 4px rgba(99,99,99,.3);/*no*/
}
</style>



// WEBPACK FOOTER //
// src/components/nav.vue